// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-header[data-v-b1cdfb2a]{align-self:center;justify-content:center;padding:2rem}.search-header h1[data-v-b1cdfb2a]{color:#fff;text-align:center;margin-bottom:2rem}.search-header form[data-v-b1cdfb2a]{max-width:450px;margin:0 auto;display:flex;flex-flow:row nowrap;align-items:flex-start}.search-header[data-v-b1cdfb2a] .vm-input{width:100%}.search-header[data-v-b1cdfb2a] .btn{margin-top:26px;padding-block:.68rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
